export function shouldUseCompiler() {
  return globalThis.__REACT_COMPILER_ENABLED__ === true;
}
